import { defineMessages } from 'react-intl';

export default defineMessages({
  viewAll: {
    id: 'viewAll',
    defaultMessage: 'View all',
  },
  hideDetails: {
    id: 'viewAll',
    defaultMessage: 'View all',
  },
});
